export default {
  data() {
    return {
      mapsStyles: [],
      mapsStylesOLD: [
        {
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#f5f5f5"
            }
          ]
        },
        {
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        },
        {
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#f5f5f5"
            }
          ]
        },
        {
          "featureType": "administrative.land_parcel",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#bdbdbd"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#eeeeee"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e5e5e5"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#dadada"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        },
        {
          "featureType": "transit.line",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e5e5e5"
            }
          ]
        },
        {
          "featureType": "transit.station",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#eeeeee"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#c9c9c9"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        }
      ]
    }
  },
  computed: {
    iconPointer () {
      let icon = {
        path: 'M0,0 0,25 50,25 62.5,12.5 50,0Z',
        fillColor: '#333',
        fillOpacity: 1,
        scale: 1,
        strokeColor: '#fff',
        strokeOpacity: 1,
        strokeWeight: 0,
      }
      if (this.googleMapsReady) {
        icon.labelOrigin = new google.maps.Point(25, 12.5);
        icon.anchor = new google.maps.Point(71, 12.5);
      }
      return icon;
    },
    iconGPSCircle () {
      return {
        path: 'M 0, 0 m -6, 0 a 6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0',
        fillColor: '#0050FF',
        fillOpacity: 1,
        scale: 1,
        strokeColor: '#fff',
        strokeOpacity: 1,
        strokeWeight: 2
      }
    },
    iconBaseCircle () {
      return {
        path: 'M 0, 0 m -6, 0 a 6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0',
        fillColor: '#fff',
        fillOpacity: 1,
        scale: 0.65,
        strokeColor: 'rgb(86, 184, 233)',
        strokeWeight: 2,
        text: 'AA',
      }
    },
    iconBus () {
      return {
        path: `M835.088 443.202c0-27.138-21.839-49.156-48.757-49.156h-641.752c-26.918 0-48.757 22.018-48.757 49.156v248.439c0 27.138 21.839 49.128 48.757 49.128h641.752c26.918 0 48.757-21.99 48.757-49.128v-248.439zM835.088 168.268c0-6.743-4.745-12.226-10.573-12.226h-119.159c-5.828 0-10.573 5.484-10.573 12.226v61.802c0 6.743 4.745 12.226 10.573 12.226h119.159c5.828 0 10.573-5.484 10.573-12.226v-61.802zM236.127 168.268c0-6.743-4.718-12.226-10.573-12.226h-119.132c-5.855 0-10.601 5.484-10.601 12.226v61.802c0 6.743 4.745 12.226 10.601 12.226h119.132c5.855 0 10.573-5.484 10.573-12.226v-61.802zM212.844 847.531c0 19.668 15.79 35.587 35.271 35.587h434.68c19.481 0 35.271-15.919 35.271-35.587v-0.699c0-19.64-15.79-35.587-35.271-35.587h-434.68c-19.481 0-35.271 15.947-35.271 35.587v0.699zM862.283 960h-793.656c-37.907 0-68.626-30.971-68.626-69.216v-836.384c0-48.233 38.767-118.4 86.608-118.4h62.938c47.814 0 86.581 70.167 86.581 118.4v0.867h458.656v-0.867c0-48.233 38.767-118.4 86.608-118.4h62.938c47.814 0 86.581 70.167 86.581 118.4v836.384c0 38.245-30.72 69.216-68.626 69.216z`,
        fillColor: '#333',
        fillOpacity: 1,
        scale: 0.1,
        strokeColor: '#ff0000',
        strokeOpacity: 1,
        strokeWeight: 1,
      }
    },    
  }

}


// WEBPACK FOOTER //
// ./src/mixins/map.js